module.exports = __webpack_public_path__ + "static/media/header-reimburse.76c54a08.jpg";